import { StyleSheet } from "react-native";
export const styles = StyleSheet.create({
  FilterRight: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  FilterItem: {
    paddingHorizontal: 0,
    display: "flex",
    flexDirection: "row",
    width: "90%",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomColor: "#D9D9D9",
    borderBottomWidth: 1,
    paddingVertical: 16,
    marginHorizontal: 16,
  },
  Label: {
    fontSize: 17,
    fontWeight: "500",
  },
  FilterValue: {
    fontSize: 16,
    color: "#707070",
    marginTop: 8,
  },
});
